import { useState } from "react";
import NavBar from "../components/Navbar/NavBar";
import Footer from "../components/Footer";
import { useDocTitle } from "../components/CustomHook";
import SVG from "../components/svg/SVG";
import { toast } from "react-toastify";
import { BrowserView, isMobile, MobileView } from "react-device-detect";

const Contact = () => {
    const [isLoading, setIsLoading] = useState(false);

    useDocTitle("Vero | Contact Us");
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [message, setMessage] = useState("");
    const [errors, setErrors] = useState([]);

    const clearErrors = () => {
        setErrors([]);
    };

    const clearInput = () => {
        setFirstName("");
        setLastName("");
        setEmail("");
        setPhone("");
        setMessage("");
    };

    const submit = (e) => {
        e.preventDefault();

        setIsLoading(true);

        const googleFormData = new FormData();

        googleFormData.append("entry.145708182", firstName);
        googleFormData.append("entry.1077035970", lastName);
        googleFormData.append("entry.1034838338", phone);
        googleFormData.append("entry.1705867003", email);

        if (message.trim().length > 0) {
            googleFormData.append("entry.1580876542", message);
        }

        const googleFormId = "1FAIpQLSfyoKOk4ZSTbEZ5nWoK_6O0kOag2KWZP-5ZzxMQpNvUX1TQmA";
        fetch(`https://docs.google.com/forms/d/e/${googleFormId}/formResponse`, {
            method: "POST",
            mode: "no-cors",
            body: googleFormData,
        })
            .then((_) => {
                console.log("Form submitted successfully!");
                toast.success("Message Successful!");
                clearInput(); // Reset form after successful submission
            })
            .catch((error) => {
                console.error("There was a problem with the fetch operation:", error);
                toast.error("Message Failed!");
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    return (
        <div>
            <div>
                <NavBar />
            </div>
            <div id="contact" className="flex justify-center items-center mt-8 w-full bg-white py-12 lg:py-24 ">
                <div className="container mx-auto my-8 px-4 lg:px-20" data-aos={isMobile ? null : "zoom-in"}>
                    <form onSubmit={submit}>
                        <div className="w-full bg-white p-8 my-4 md:px-12 lg:w-9/12 lg:pl-20 lg:pr-40 mr-auto rounded-2xl shadow-2xl">
                            <div className="flex">
                                <h1 className="font-bold text-center lg:text-left fg-primary uppercase text-4xl">
                                    Send us a message
                                </h1>
                            </div>
                            <div className="grid grid-cols-1 gap-5 md:grid-cols-2 mt-5">
                                <div>
                                    <input
                                        name="first_name"
                                        className="w-full bg-gray-100 text-gray-900 mt-2 p-3 rounded-lg focus:outline-none focus:shadow-outline"
                                        type="text"
                                        placeholder="First Name*"
                                        value={firstName}
                                        onChange={(e) => setFirstName(e.target.value)}
                                        onKeyUp={clearErrors}
                                        required={true}
                                    />
                                    {errors && <p className="text-red-500 text-sm">{errors.first_name}</p>}
                                </div>

                                <div>
                                    <input
                                        name="last_name"
                                        className="w-full bg-gray-100 text-gray-900 mt-2 p-3 rounded-lg focus:outline-none focus:shadow-outline"
                                        type="text"
                                        placeholder="Last Name*"
                                        value={lastName}
                                        onChange={(e) => setLastName(e.target.value)}
                                        onKeyUp={clearErrors}
                                        required={true}
                                    />
                                    {errors && <p className="text-red-500 text-sm">{errors.last_name}</p>}
                                </div>

                                <div>
                                    <input
                                        name="email"
                                        className="w-full bg-gray-100 text-gray-900 mt-2 p-3 rounded-lg focus:outline-none focus:shadow-outline"
                                        type="email"
                                        placeholder="Email*"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        onKeyUp={clearErrors}
                                        required={true}
                                    />
                                    {errors && <p className="text-red-500 text-sm">{errors.email}</p>}
                                </div>

                                <div>
                                    <input
                                        name="phone_number"
                                        className="w-full bg-gray-100 text-gray-900 mt-2 p-3 rounded-lg focus:outline-none focus:shadow-outline"
                                        type="number"
                                        placeholder="Phone*"
                                        value={phone}
                                        onChange={(e) => setPhone(e.target.value)}
                                        onKeyUp={clearErrors}
                                        required={true}
                                    />
                                    {errors && <p className="text-red-500 text-sm">{errors.phone_number}</p>}
                                </div>
                            </div>
                            <div className="my-4">
                                <textarea
                                    name="message"
                                    placeholder="Message (Optional)"
                                    className="w-full h-32 bg-gray-100 text-gray-900 mt-2 p-3 rounded-lg focus:outline-none focus:shadow-outline"
                                    value={message}
                                    onChange={(e) => setMessage(e.target.value)}
                                    onKeyUp={clearErrors}
                                ></textarea>
                                {errors && <p className="text-red-500 text-sm">{errors.message}</p>}
                            </div>
                            <div className="my-2 w-1/2 lg:w-2/4">
                                <button
                                    type="submit"
                                    id="submitBtn"
                                    className="uppercase text-sm font-bold tracking-wide bg-primary bg-secondary-hover text-white p-3 rounded-lg w-full 
                                    focus:outline-none focus:shadow-outline"
                                >
                                    {isLoading ? "Loading..." : "Send Message"}
                                </button>
                            </div>
                        </div>
                    </form>
                    <div className="w-full  lg:-mt-96 lg:w-2/6 px-8 py-6 ml-auto bg-primary rounded-2xl">
                        <div className="flex flex-col text-white">
                            <div className="flex my-4 w-2/3 lg:w-3/4">
                                <div className="flex flex-col">
                                    <i className="fas fa-map-marker-alt pt-2 pr-2" />
                                </div>
                                <div className="flex flex-col">
                                    <h2 className="text-2xl">Office Address</h2>
                                    <p className="text-gray-400">
                                        26 Pointer Crescent, Garsfontein, Pretoria, South Africa
                                    </p>
                                </div>
                            </div>

                            <div className="flex my-4 w-2/3 lg:w-1/2">
                                <div className="flex flex-col">
                                    <i className="fas fa-phone-alt pt-2 pr-2" />
                                </div>

                                <div className="flex flex-col">
                                    <h2 className="text-2xl">Call Us</h2>
                                    <a className="text-gray-400" href="tel:0713314469">
                                        071 331 4469
                                    </a>

                                    <div className="mt-5">
                                        <h2 className="text-2xl">Send an E-mail</h2>
                                        <a className="text-gray-400" href="mailto:irene@veroaccounting.co.za">
                                            irene@veroaccounting.co.za
                                        </a>
                                    </div>
                                </div>
                            </div>

                            <div className="flex my-4 w-2/3 lg:w-1/2">
                                <a
                                    href="https://www.linkedin.com/company/vero_accounting"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="flex justify-center items-center fg-primary hover:text-gray-500 bg-white hover:bg-white-100 rounded-full shadow transition duration-50 ease-in-out mr-5"
                                    aria-label="LinkedIn"
                                >
                                    {SVG.linkedIn}
                                </a>
                                <a
                                    href="https://www.facebook.com/profile.php?id=61575972264023"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="flex justify-center items-center fg-primary hover:text-gray-500 bg-white hover:bg-white-100 rounded-full shadow transition duration-50 ease-in-out mr-5"
                                    aria-label="Facebook"
                                >
                                    {SVG.facebook}
                                </a>
                                <a
                                    href="https://www.instagram.com/vero_accounting/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="flex justify-center items-center fg-primary hover:text-gray-500 bg-white hover:bg-white-100 rounded-full shadow transition duration-50 ease-in-out"
                                    aria-label="Instagram"
                                >
                                    {SVG.instagram}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default Contact;
